(function () {
  function getLuminance(r, g, b) {
    const toLinear = (c) => {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  }

  function getBgColor(el) {
    while (el && el !== document.body) {
      const bg = window.getComputedStyle(el).backgroundColor;
      const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
      if (match) {
        const [, r, g, b] = match.map(Number);
        if (!(r === 0 && g === 0 && b === 0 && bg.includes('0)'))) {
          return { r, g, b };
        }
      }
      el = el.parentElement;
    }
    return { r: 255, g: 255, b: 255 }; // Fallback: hell
  }

  function updateMenuColor() {
    const header = document.querySelector('header, .header, [data-section-type="header"]');
    if (!header) return;

    const headerBottom = header.getBoundingClientRect().bottom;
    const centerX = window.innerWidth / 2;
    const elementBelow = document.elementFromPoint(centerX, headerBottom + 1);
    if (!elementBelow) return;

    const { r, g, b } = getBgColor(elementBelow);
    const luminance = getLuminance(r, g, b);
    const isDark = luminance < 0.179;

    const menuLinks = header.querySelectorAll('nav a, .header__menu a, .header-menu a, [class*="nav"] a');
    menuLinks.forEach((link) => {
      link.style.setProperty('color', isDark ? '#ffffff' : '#000000', 'important');
    });
  }

  window.addEventListener('scroll', updateMenuColor, { passive: true });
  window.addEventListener('load', updateMenuColor);
})();
